import './Returns.css';
import '../Dashboard.css';
import Search from './Search/Search.js';
import Upload from './Upload/Upload.js';
import { useMemo, useState } from 'react';

const VIEWS = [
    {
        id: 'search-returns',
        title: 'Search',
        component: Search,
    },

];
const DEFAULT_VIEW = VIEWS[0];

function Returns({ toggleNav }) {
    const [view, setView] = useState(DEFAULT_VIEW);

    const renderView = useMemo(() => {
        const View = view.component;
        return <View key={view.id} toggleNav={toggleNav} />
    }, [view.id, toggleNav]);

    return (

        <div className="Returns">
            {renderView}
        </div>
    );
}

export default Returns;
